import { CLASSNAME_HIDDEN } from '@vfde-brix/core';
import { CLASSNAME_VISUALLY_HIDDEN } from 'Constant';

/**
 * toggle visibility of a DOM element
 */
export const setIsVisible = (element: HTMLElement | null, show: boolean) => {
    element && element.classList.toggle(CLASSNAME_VISUALLY_HIDDEN, !show);
};

export const setElementVisibility = (target: HTMLElement | null | string, visible: boolean): void => {
    const element = 'string' === typeof target
        ? document.getElementById(target)
        : target;

    element?.classList.toggle(CLASSNAME_HIDDEN, !visible);
};
